import React from "react";
import googleLogo from "../../assets/logo/google.png";

const GoogleButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-center gap-3 border border-[#ABABAB] rounded-lg py-2 px-4 hover:bg-gray-100 transition"
    >
      <img src={googleLogo} alt="Google Logo" className="w-5 h-5" />
      <span className="text-[14px] font-medium text-[#333333] font-montserrat">
        Lanjutkan dengan Google
      </span>
    </button>
  );
};

export default GoogleButton;
